<template>
  <v-card>
    <v-card-title class="headline"
      >Confirmar acción
      <v-btn
        style="right: 10px; top: 10px"
        icon
        color="primary"
        fab
        absolute
        @click="$emit('cancel')"
      >
        <v-icon dark>fa-times</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <h3 class="mt-5 ml-5">
        ¿Está seguro que desea eliminar
        <span>{{ name }}</span
        >?
      </h3>
    </v-card-text>

    <v-card-actions style="justify-content: center">
      <v-btn
        color="red darken-4"
        dark
        class="mb-3"
        width="95%"
        rounded
        :min-height="48"
        :loading="loading"
        @click="$emit('confirm')"
      >
        Eliminar
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: ["name", "loading"],
};
</script>